/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Detail_Toggle_HideInputs */



/**
* | output |
* | --- |
* | "Hide individual ratings" |
*
* @param {Feedback_Detail_Toggle_HideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const feedback_detail_toggle_hide = /** @type {((inputs?: Feedback_Detail_Toggle_HideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Detail_Toggle_HideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einzelbewertungen ausblenden")
	return /** @type {LocalizedString} */ ("Hide individual ratings")
});